/**
 * @file m站 帮助中心
 */

import React, {Component} from 'react';
import {NavBar, List, Icon} from 'antd-mobile';
import NavBarComponent from '../../../component/common/NavBarComponent'
import './helpCenter.scss';

const Item = List.Item;

const qaMobile = `tel:${window.LXOptions.tel}`; 
class HelpCenter extends Component {
    constructor() {
        super();
        this.state = {
            lists: [
                {
                    text: "常见问题",
                    url: "/commonProblem",
                    thumb: "../../../assets/question.png",
                    ispage: true,
                    datas: "https://h5.izuche.com/help/Commonproblem.html",
                },
                {
                    text: "服务规则",
                    url: "/serviceRule",
                    thumb: "../../../assets/rule.png",
                    ispage: false,
                },
                {
                    text: "安全须知",
                    url: "/commonProblem",
                    thumb: "../../../assets/safe.png",
                    ispage: true,
                    datas: "https://h5.izuche.com/help/Safetyinstructions.html",
                },
                {
                    text: "意见反馈",
                    url: "/feedBack",
                    thumb: "../../../assets/ask.png",
                    ispage: false,
                },
                // {
                //   text: "客服电话",
                //   url: "../common-problem/common-problem",
                //   thumb: "iconfont icon-customercell",
                //   ispage: false,
                // },
            ]
        };
    }

    goPage(item) {
        const { ispage, url, datas, text } = item
        const {history} = this.props
        if (!!ispage) {
            this.props.history.push({
                pathname: '/webview',
                query: { url:datas, title:text }
            })
        } else {
            history.push({
                pathname: url
            })
        }
    }

    render() {
        return (
            <div id="helpcenter" className="page">
                <NavBarComponent>
                    <NavBar icon={<Icon type="left" color='#333' />} 
                    onLeftClick={() => {this.props.history.goBack()}}  mode='light'>帮助中心</NavBar>
                </NavBarComponent>
                <List>
                    {this.state.lists.map((item, index) => {
                        return <Item arrow="horizontal" className="bb" key={index}>
                                    <div className="fs24 list-item" style={{display: 'flex', alignItems: 'center', align: 'middle'}} onClick={() => {this.goPage(item)}}>
                                        <span className="img" style={{backgroundImage: "url("+item.thumb+")"}}></span>
                                        <div>{item.text}</div>
                                    </div>
                                </Item>
                    })}
                    <Item arrow="horizontal" className="bb">
                        <a className="fs24 list-item" style={{display: 'flex', alignItems: 'center', align: 'middle'}} href={qaMobile}>
                            <span className="img" style={{backgroundImage: "url(/assets/customer.png)"}}></span>
                            <div>客服电话</div>
                        </a>
                    </Item>
                </List>
            </div>
        );
    }
}

export default HelpCenter;
